import {Message, Loading} from 'element-ui'
let loading;
export default {
  install(Vue, options) {
    /**
     * @Description:  强制转换两位小数（正数）
     * @param:  val: 需要转换的值
     * @Author: ZhangBin
     * @Date
     */
    Vue.prototype.toDecimal = (val) => {
      if (isNaN(parseFloat(val)) || isNaN(val)) {
        return '';
      }
      let f = Math.round(val*100)/100;
      let s = f.toString();
      let rs = s.indexOf('.');
      if (rs < 0) {
        rs = s.length;
        s += '.';
      }
      while (s.length <= rs + 2) {
        s += '0';
      }
      return s;
    };
    /**
     * @Description:  数字验证（小数，非负数）
     * @param:
     * @Author: ZhangBin
     * @Date 2018/12/6 上午11:19
     */
    Vue.prototype.checkDecimalNumber = (val) => {
      if (isNaN(parseFloat(val)) || isNaN(val)) {
        Message({
          message: '请输入数字！',
          type: 'error',
          duration: 2000
        });
        return 0;
      }
      else if(/^[-]\d+[.]?\d*$/.test(val)) {
        Message({
          message: '请输入正数！',
          type: 'error',
          duration: 2000
        });
        return 0;
      }
      else {
        return val;
      }
    };
    Vue.prototype.checkNumber = (val) => {
      if(val!==''){
        if((isNaN(parseFloat(val)) || isNaN(val))) {
          Message({
            message: '请输入数字！',
            type: 'error',
            duration: 2000
          });
          return '';
        }
        else if(/^[-]\d+[.]?\d*$/.test(val)) {
          Message({
            message: '请输入正数！',
            type: 'error',
            duration: 2000
          });
          return '';
        }
        else {
          return val;
        }
      }

    };
    /**
     * @Description:  千分位格式化并保留两位小数
     * @param:
     * @Author: ZhangBin
     * @Date 2018/12/10 下午8:01
     */
    Vue.prototype.thousandsDecimalNumber = (val, flag = true) => {
      if(isNaN(parseFloat(val)) || isNaN(val)) return '0';
      let num;
      if(flag) {
        num = String(val.toFixed(2));
      } else {
        num = String(val);
      }
      let reg = /(-?\d+)(\d{3})/;
      while(reg.test(num)) {
        num = num.replace(reg,"$1,$2");
      }
      return num;
    };
    /**
     * @Description: 根据classname获取元素
     * @param:  classname: class名
     * @Author: ZhangBin
     * @Date
     */
    Vue.prototype.getEleByClass = (classname) => {
      var tags = document.all ? document.all : document.getElementsByTagName('*');
      var arr = [];
      // var reg = /\bclassname\b/g;//普通方式定义
      var reg = new RegExp('\\b'+classname+'\\b','g');//构造函数方式
      for (var i = 0; i < tags.length; i++) {
        reg.lastIndex = 0;
        if (reg.test(tags[i].className)) {
          arr.push(tags[i]);
        }
      }
      return arr;
    };
    /**
     * @Description:  判断数据是否为字符串null
     * @param:
     * @Author: ZhangBin
     * @Date 2018/12/6 下午8:49
     */
    Vue.prototype.checkIsStrNull = (val) => {
      if(val == 'null' || val == null) {
        return '';
      } else {
        return val;
      }
    };
    /**
     * @Description:  控制台输出信息
     * @param:
     * @Author: ZhangBin
     * @Date 2018/12/7 上午11:29
     */
    Vue.prototype.log = (message) => {
      console.log('%o', message);
    };

    Vue.prototype.error = (message) => {
      console.error('%c'+ message +'','background:#F00; color:#FFFFFF; font-size: 14px;');
    };
    /**
     * @Description: 加载loading效果
     * @param:
     * @Author: ZhangBin
     * @Date 2018/12/10 下午1:51
     */
    Vue.prototype.loading = (target = document.getElementById('elMain'), text = '加载中……') => {
      loading = Loading.service({
        target: document.getElementById('elMain'),
        lock: true,
        text: text,
        background: 'rgba(255, 255, 255, 0.6)',
        spinner: 'loading_icon iconfont icon-loading',
      })
    };
    Vue.prototype.closeLoading = () => {
      loading.close();
    };
    /**
     * @Description:  生成uuid
     * @param:
     * @Author: ZhangBin
     * @Date 2018/12/29 上午11:00
     */
    Vue.prototype.createUuid = () => {
      let s = [];
      let hexDigits = "0123456789abcdef";
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

      let uuid = s.join("");
      return uuid;
    };
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js